import React from 'react';
import './spinner.scss'
const Spinner = ({ classTo }) => (
	<div className={`Spinner SpinnerDots ${classTo ? classTo : ''}`}>
		<div className="spinner-dot" />
		<div className="spinner-dot" />
		<div className="spinner-dot" />
	</div>
);

export default Spinner;